import { Container, Box } from '@mui/material';
import LoginForm from '../features/auth/LoginForm';

const LoginPage = () => {
    return (
        // Use a wrapping Box for the full background and viewport height
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // Optional: Add a subtle background color or gradient for visual interest
                bgcolor: 'grey.50', 
                py: 4, // Add padding on the Y-axis for smaller screens
            }}
        >
            <Container maxWidth="xs"> 
                {/* Changed maxWidth to 'xs' for a tighter, more focused login card */}
                <LoginForm />
            </Container>
        </Box>
    );
};

export default LoginPage;